<template lang="pug">
modal#show-envelope-in-review-by-another-user-modal(
  :process-button-label='$t("modal.unableEnvelopeFurtherActions.button")'
  :show-cancel-button='false'
  :title='$t("pages.waiting-review.modal.title")'
  @process='closeModal'
  ref='modal'
)
  .text {{ $t('waitingReviewEnvelopesCardTable.insufficientPermission', { userRevisor: envelopeSender }) }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/application-warning.svg')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'ShowEnvelopeInReviewByAnotherUserModal',
  components: {
    Modal,
  },
  props: {
    envelopeSender: {
      type: String,
      default: '',
    },
  },
  methods: {
    closeModal() {
      this.$refs.modal.close();
    },
    open() {
      this.$refs.modal.open();
    },
  },
};
</script>
